import StyledWMDialog from '../StyledWMDialog/StyledWMDialog';
import { WMButtonVariant } from '@walkme/wm-ui';
import React from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import classes from './ConfirmDialog.module.scss';
import { useTranslation } from 'react-i18next';

const keyPrefix = '';

interface IConfirmDialogProps extends InstanceProps<boolean> {
    hideCancel?: boolean;
    dataTestId: string;
    title: string;
    confirmText?: string;
    confirmDelete?: boolean;
    children?: $TSFixMe;
    className?: string;
}
export const ConfirmDialog = ({
    isOpen,
    onResolve,
    hideCancel = false,
    close,
    dataTestId,
    title,
    confirmText,
    children,
    confirmDelete,
    className
}: IConfirmDialogProps) => {
    const { t } = useTranslation('', { keyPrefix });
    const confirm = () => {
        onResolve(true);
    };

    const onClose = () => {
        close();
    };

    const buttons = hideCancel
        ? [
              {
                  children: confirmText ?? t('common.confirm'),
                  variant: WMButtonVariant.Primary,
                  onClick: confirm,
                  'data-testid': `${dataTestId}-confirm-button`
              }
          ]
        : [
              {
                  children: t('common.cancel'),
                  variant: WMButtonVariant.Primary,
                  onClick: onClose,
                  className: classes.cancelButton,
                  'data-testid': `${dataTestId}-decline-button`
              },
              {
                  children: confirmText ?? t('common.confirm'),
                  variant: WMButtonVariant.Primary,
                  onClick: confirm,
                  className: confirmDelete ? classes.deleteButton : undefined,
                  'data-testid': `${dataTestId}-confirm-button`
              }
          ];

    return (
        <StyledWMDialog
            title={title}
            open={isOpen}
            onClose={onClose}
            buttons={buttons}
            data-testid={dataTestId}
            {...(className ? { className } : {})}
        >
            {children}
        </StyledWMDialog>
    );
};

export const confirmDialog = create<IConfirmDialogProps>(ConfirmDialog);
